import React, { Component, Fragment } from "react";
import "./Home.scss";
import Ztext from "react-ztext";

import fb from "../../assets/fb.png";
import ig from "../../assets/ig.png";
import linkedIn from "../../assets/in.png";
import twitter from "../../assets/twitter.png";
import wa from "../../assets/wa.png";

export default class Home extends Component {
  render() {
    return (
      <Fragment>
        <section id="home-container">
          <div className="home-bg-circle">
            <div>
              <div className="home-fullname">
                <Ztext
                  depth="0.5rem"
                  direction="both"
                  event="pointer"
                  eventRotation="20deg"
                  eventDirection="default"
                  fade={true}
                  layers={10}
                  perspective="500px"
                  style={{
                    fontSize: "3rem",
                  }}
                >
                  Jeffri Andriyanto
                </Ztext>
                <Ztext
                depth="0.2rem"
                direction="both"
                event="pointer"
                eventRotation="20deg"
                eventDirection="default"
                fade={true}
                layers={10}
                perspective="300px"
                style={{
                  fontSize: "1.5rem"
                }}
              >
                Frontend Web Developer
              </Ztext>
              </div>
            </div>
          </div>

          <div className="home-social-media">
            <a href="https://www.facebook.com/jeffri.t.m/" target="_blank" rel="noreferrer">
              <img src={fb} className="icon" alt="facebook" />
            </a>
            <a href="https://www.instagram.com/jeffri_andriyanto/" target="_blank" rel="noreferrer">
              <img src={ig} className="icon" alt="instagram" />
            </a>
            <a href="https://www.linkedin.com/in/jeffri-andriyanto-226599b3/" target="_blank" rel="noreferrer">
              <img src={linkedIn} className="icon" alt="linkedin" />
            </a>
            <a href="https://twitter.com/jeffri_ay" target="_blank" rel="noreferrer">
              <img src={twitter} className="icon" alt="twitter" />
            </a>
            <a href="https://api.whatsapp.com/send?phone=628164250780&text=Hai Jeffi, Ayo berkolaborasi" target="_blank" rel="noreferrer">
              <img src={wa} className="icon" alt="whatsapp" />
            </a>
          </div>

          {/*  */}
        </section>
      </Fragment>
    );
  }
}
